import AWSIot from 'aws-iot-device-sdk';
import { guid } from '../utils/commonUtils';
import { IOT_MESSAGE_BROKER } from '../config/config';
import InstrumentGroupCredentials from './instrument-group-credentials';

export type TopicStub = 'get' | 'update' | 'delete';
export default class InstrumentNamedShadow {
  private thingShadow: AWSIot.thingShadow | undefined;

  private instrumentCredentials: InstrumentGroupCredentials;

  private isConnectionActive = false;

  constructor(instrumentCredentials: InstrumentGroupCredentials) {
    this.instrumentCredentials = instrumentCredentials;
    this.startWebsocketConnection();
  }

  private startWebsocketConnection(): void {
    if (!this.isConnectionActive) {
      // @ts-ignore
      this.thingShadow = AWSIot.thingShadow({
        host: IOT_MESSAGE_BROKER.ENDPOINT,
        clientId: guid(),
        protocol: 'wss',
        maximumReconnectTimeMs: 8000,
        accessKeyId: this.instrumentCredentials.accessKeyId,
        secretKey: this.instrumentCredentials.secretKey,
        sessionToken: this.instrumentCredentials.sessionToken
      });

      this.isConnectionActive = true;
    }
  }

  public updateNamedShadow(
    instrumentId: string,
    shadowName: string,
    desiredState: Record<string, unknown>
  ): void {
    const desiredStateFormat = JSON.stringify(desiredState);
    this.publishToNamedShadow(instrumentId, shadowName, 'update', desiredStateFormat);
  }

  public subscribeToNamedShadow(
    instrumentId: string,
    shadowName: string,
    topicStub: TopicStub,
    callback: (topic: string, payload: unknown) => void
  ): void {
    const shadowTopic = `$aws/things/${instrumentId}/shadow/name/${shadowName}/${topicStub}`;
    const shadowAcceptedTopic = `${shadowTopic}/accepted`;
    const shadowRejectedTopic = `${shadowTopic}/rejected`;

    this.startWebsocketConnection();

    const shadowTopicsToSubscribe = [shadowAcceptedTopic, shadowRejectedTopic];
    this.thingShadow?.subscribe(shadowTopicsToSubscribe, { qos: 1 });
    this.thingShadow?.on('message', callback);
  }

  public publishToNamedShadow(
    instrumentId: string,
    shadowName: string,
    topicStub: TopicStub,
    message?: string
  ): void {
    this.startWebsocketConnection();

    const shadowTopic = `$aws/things/${instrumentId}/shadow/name/${shadowName}/${topicStub}`;
    this.thingShadow?.publish(shadowTopic, message ?? '', { qos: 1 });
  }

  public unsubscribeNamedShadow(
    instrumentId: string,
    shadowName: string,
    topicStub: TopicStub
  ): void {
    const shadowTopic = `$aws/things/${instrumentId}/shadow/name/${shadowName}/${topicStub}`;
    const shadowAcceptedTopic = `${shadowTopic}/accepted`;
    const shadowRejectedTopic = `${shadowTopic}/rejected`;

    this.startWebsocketConnection();

    const shadowTopicsToUnsubscribe = [shadowAcceptedTopic, shadowRejectedTopic];
    this.thingShadow?.unsubscribe(shadowTopicsToUnsubscribe);
  }

  public closeWebsocketConnection() {
    this.thingShadow?.end();
    this.isConnectionActive = false;
  }
}
